import { Deserializable } from '../../protocols/deserializable';
import { InternalUserProfile } from './internal-user-profile';
import { SubmissionReminder } from '../../submissions/member-submission';
import { DeathRecordStatusIdEnum } from '../../enum/shared/death-record-status-id.enum';
import { MemberDeathRecordNotifyingParty } from './member-death-record-notifying-party';
import { MemberDeathRecordLegalRepresentative } from './member-death-record-legal-representative';
import { MemberDeathRecordAccount } from './member-death-record-account';
import { MemberDeathRecordAttachment } from './member-death-record-attachment';

export class MemberDeathRecord implements Deserializable {
  public id!: number;
  public memberId!: number;
  public statusId!: DeathRecordStatusIdEnum;
  public createdDate!: string;
  public ownerId!: number;
  public owner!: InternalUserProfile;
  public deathDate: string | null = null;
  public notificationDate: string | null = null;
  public contactMethodId: number | null = null;
  public reminder: SubmissionReminder | null = null;
  public notifyingParty: MemberDeathRecordNotifyingParty | null = null;
  public legalRepresentative: MemberDeathRecordLegalRepresentative | null = null;
  public spouseId: number | null = null;
  public settlementCount: number = 0;
  public unreleasedSettlementCount: number = 0;
  public openSettlementCount: number = 0;
  public accounts: MemberDeathRecordAccount[] = [];
  public attachments: MemberDeathRecordAttachment[] = [];

  public displayId!: string;

  public onDeserialize(): void {
    this.owner = window.injector.Deserialize.instanceOf(InternalUserProfile, this.owner);
    if (this.reminder) {
      this.reminder = window.injector.Deserialize.instanceOf(SubmissionReminder, this.reminder);
    }
    if (this.notifyingParty) {
      this.notifyingParty = window.injector.Deserialize.instanceOf(
        MemberDeathRecordNotifyingParty,
        this.notifyingParty
      );
    }
    if (this.legalRepresentative) {
      this.legalRepresentative = window.injector.Deserialize.instanceOf(
        MemberDeathRecordLegalRepresentative,
        this.legalRepresentative
      );
    }
    this.accounts = window.injector.Deserialize.arrayOf(MemberDeathRecordAccount, this.accounts ?? []);
    this.attachments = window.injector.Deserialize.arrayOf(MemberDeathRecordAttachment, this.attachments ?? []);
    this.displayId = `DTH-${String(this.id).padStart(6, '0')}`;
  }
}
